import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/allen-school-ui_main/node_modules/next/dist/client/image-component.js");
